import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    email: yup.string().trim().email().label('Email').required(),
    role_type: yup.string().trim().label('Role').required()
  });
};
